import { addLinkAssetLOTO } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from "@mui/material";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
	AssetId: number | string;
	searchAssetResources?: Function;
	setRemoveLOTOError: Function;
	WorkOrderName: string;
	AssetName: string;
};

export const AssetAddLOTODialog = ({
	show,
	onHide,
	AssetId,
	searchAssetResources,
	setRemoveLOTOError,
	WorkOrderName,
	AssetName,
}: Props) => {
	const {
		state: { workOrderLOTOToAdd },
	} = useWorkOrderModalsContext();

	const addResourcesToAsset = async () => {
		if (workOrderLOTOToAdd) {
			const res = await addLinkAssetLOTO(
				AssetId,
				workOrderLOTOToAdd.LOTONumber,
				workOrderLOTOToAdd.LOTOName,
				"",
			);
			if (res.ok) {
				if (searchAssetResources) {
					searchAssetResources();
					onHide(true);
				}
			} else {
				setRemoveLOTOError(res.message);
				onHide(false);
			}
		}
	};

	return (
		<Dialog open={show} aria-labelledby="responsive-dialog-title">
			<DialogTitle style={{ paddingBottom: 6 }} id="responsive-dialog-title">
				{`Add LOTO to Asset: ${AssetName}`}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					The following LOTO: {workOrderLOTOToAdd.LOTOName} have been added to
					the work order {WorkOrderName}. Would you like to add them to the
					corresponding asset as well?
				</DialogContentText>
			</DialogContent>
			<DialogActions style={{ padding: "24px" }}>
				<Button
					variant="contained"
					fullWidth
					color="inherit"
					onClick={() => onHide(false)}
				>
					SKIP
				</Button>
				<Button
					fullWidth
					variant="contained"
					onClick={addResourcesToAsset}
					color="primary"
					autoFocus
				>
					ADD
				</Button>
			</DialogActions>
		</Dialog>
	);
};
